/**
 * @Author: 左建
 * @Date: 2022/7/20 16:44
 * @LastEditTime: 2022/7/20 16:44
 * @Description: 学生端问卷接口
*/

import { post, postFormData } from "@/utils/request";
import { clearObjEmptyStr } from "@/utils";

// 获取问卷列表
export function getQuestionnaireList (data) {
    return post("/Manage/Questionnaire/GetListForStudent", clearObjEmptyStr(data), true, clearObjEmptyStr(data))
}

// 提交问卷
export function submitQuestionnaire (data) {
    return post("/Manage/Questionnaire/SaveAnswers", undefined, undefined, data)
}

// 导出问卷统计报告
export function exportReport (detailId) {
    return postFormData("/Manage/Questionnaire/ExportStatisticsReport", { detailId })
}
// 根据id和学生id获取查看答案
export function getStudentAnswer (Qid, userId) {
    return post("/Manage/Questionnaire/GetByStuId", {
        Id: Qid,
        userid: userId
    }, undefined, {
        Id: Qid,
        userid: userId
    })
}
